<div class="modal-header">
    <div class="title">
      <h2 class="modal-title-prefix"><span translate="PLACANJERACUNA.SINGULAR"></span></h2>
      <h1 class="modal-title">
        <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="PLACANJERACUNA.NEW"></span></span>
        <span *ngIf="baseUpdate.Item.ID > 0"><span>{{baseUpdate.Item.Naziv}}</span></span>
      </h1>
    </div>
    <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
  </div>
  <div class="modal-body">
    <yt-placanje-racuna-update #baseUpdate></yt-placanje-racuna-update>
  </div>
  <div class="modal-footer">
    <!-- <button type="submit" class="btn btn-primary" (click)="Save()"><span [innerHTML]="'FW.ACTION.SAVE.ACTION' | translate">Sačuvaj</span></button>
    <button type="button" class="btn btn-secondary" (click)="Close()"><span>Odustani</span></button> -->
    <button type="submit" class="btn btn-primary" (click)="Save()"><span [innerHTML]="'FW.ACTION.SAVE.ACTION' | translate">Sačuvaj</span></button>  
    <button type="button" class="btn btn-secondary" (click)="Close()"><span [innerHTML]="'FW.ACTION.CANCEL' | translate">Zatvori</span></button>  
  </div>